module.exports = __webpack_public_path__ + "img/dred-sam-scott.1cf62c38.png";